import Auth from './auth'
import Subscription from './Subscription'
import Guest from './guest'
import Permission from './permission'
import BaseMiddleware from './BaseMiddleware'

export default {
    auth: Auth,
    guest: Guest,
    permission: Permission,
    baseMiddleware: BaseMiddleware,
    subscription: Subscription,
}
